import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block select-none rounded-full bg-black-900 px-[0.4rem] text-center text-12 font-bold text-white"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($data.itemsCount > 0)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($data.itemsCount), 1))
    : _createCommentVNode("", true)
}